<template>
  <div>
    <a-card size="small" class="custom-card" title="Budget COA Configuration" style="width: 100%;">
      <a-table
      size="small"
      rowKey="key"
      :columns="columns" 
      :data-source="data_table"
      :loading="loading.table"
      :pagination="false"
      :expanded-row-keys="expandedRowKeys"
      class="custom-table"
      @expand="onExpand"
      bordered>
        <template slot="item" slot-scope="text, item, index">
            <span :style="{ fontWeight: isParent(item) ? 'bold' : 'normal' }">
              {{ item.kode_anggaran ? `[${item.kode_anggaran}] - ` : '' }}{{ item.item }}{{ item.level == 1 ? ` - ${item.tahun}` : "" }}
            </span>
            <a-button v-if="item.editable && item.level < 5" class="button-edit" type="primary" icon="edit" size="small" @click="showModalAdd(item)">Edit</a-button>
            <!-- <a-button v-if="item.editable && item.level == 5" class="button-edit" type="danger" style="margin-left: 10px;" icon="delete" size="small" @click="showModalDelete(item)"></a-button> -->
            <!-- <a-button v-if="item.editable && item.level == 5" class="button-edit" icon="edit" size="small" @click="showModalEdit(item)"></a-button> -->
        </template>
        <!-- <template slot="kode_anggaran" slot-scope="text, item, index">
          {{ item.kode_anggaran }}
        </template> -->
        <template slot="total" slot-scope="text, item, index">
          {{ customFormatCurrency('IDR', item.total) }}
        </template>
        
      </a-table>
    </a-card>

    <a-modal :visible="modal_add" @cancel="onModalAddClose" :footer="null" :maskClosable="false" width="80%">
      <span slot="title"> <a-icon type="edit" /> {{ modal_state }} COA : {{ edit_state.kode_anggaran }}</span>

      <a-row :gutter="[8, 8]">
        <a-col :span="10">
          <a-card>
            <div class="card-title">
              <span>Coa Name : {{ edit_state.item }}</span>
              <span>Total : <strong>{{ customFormatCurrency('IDR', edit_state.total) }}</strong></span>
            </div>
          </a-card>
        </a-col>
        <a-col :span="14">
          <a-card>
            <div class="card-title">
              <span>Remaining : {{ remainingPercentage }}%</span>
              <span>Total : {{ customFormatCurrency('IDR', remainingValue) }}</span>
            </div>
          </a-card>
        </a-col>
        <a-col :span="10">
          <a-card>
            <a-form :form="form_create">
              <a-row :gutter="8">
                <a-col :span="24">
                  <a-form-item label="Coa">
                      <a-tree-select
                        style="width: 100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        :tree-data="coa_list"
                        placeholder="Please select"
                        show-search
                        tree-node-filter-prop="title"
                        tree-default-expand-all
                        v-decorator="['coa_id', { rules: [{ required: true, message: 'COA wajib diisi' }] } ]"
                      >
                      </a-tree-select>
                    </a-form-item>

                    <a-form-item label="Percentage">
                      <a-input-number type="number" class="m-width-full m-text-align-right"
                      :min="0"
                      :max="100"
                      :formatter="value => `${value}%`"
                      :parser="value => value.replace('%', '')" 
                      @change="onChangePercentage"
                      v-decorator="[
                        'percentage',
                        { rules: [{ required: true }]},
                      ]" />
                    </a-form-item>

                    <a-form-item label="Value">
                      <a-input-number type="number" class="m-width-full m-text-align-right"
                        disabled
                        v-on:keydown.enter.prevent="preventEnterButton" 
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                        v-decorator="['value_coa',{ rules: [{ required: true }] },
                      ]" />
                    </a-form-item>
                    <div class="form-action-section">
                      <a-button v-if="button_state == 'Update'" type="secondary" @click="cancelEdit">Cancel</a-button>
                      <a-button :icon="button_state == 'Add' ? 'plus' : 'save'" type="primary" @click="addDetail">{{button_state}}</a-button>
                    </div>
                </a-col>
              </a-row>
            </a-form>
          </a-card>
        </a-col>
        <a-col :span="14">
          <a-table
          :columns="columns_coa"
          :data-source="edit_coa_list"
          :pagination="pagination"
          bordered
          >
            <template slot="item" slot-scope="text, item, index">
              {{ item.item }}
            </template>

            <template slot="percentage" slot-scope="text, item, index">
              {{ item.persentase }}%
            </template>

            <template slot="total" slot-scope="text, item, index">
              {{ customFormatCurrency('IDR', item.nilai) }}
            </template>

            <template slot="action" slot-scope="text, item, index">
              <div class="action-wrapper">
                <a-button icon="edit" size="small" @click="editCoaHanlder(item)"></a-button>
                <!-- <a-button icon="delete" size="small" type="danger" @click="deleteCoaList(item.coa_id)"></a-button> -->
                <a-popconfirm
                  title="Are you sure delete this COA?"
                  ok-text="Yes"
                  cancel-text="No"
                  @confirm="deleteCoaList(item.coa_id)"
                  @cancel="cancelDelete"
                >
                  <a-button icon="delete" size="small" type="danger"></a-button>

                </a-popconfirm>
              </div>
            </template>

          </a-table>

          <div class="total-section">
            <span>Total Percentage: <strong>{{ totalPercentage }}%</strong></span>
            <span><strong>{{ customFormatCurrency('IDR', totalNilai) }}</strong></span>
          </div>
        </a-col>

        <a-col :span="24">
          <div class="footer-card">
            <a-button type="secondary" html-type="submit" @click="onModalAddClose">Cancel</a-button>
            <a-button v-if="modal_state == 'Create'" :loading="loading.submit" type="primary" html-type="submit" @click="onSubmitCreate"><b>Submit</b></a-button>
            <a-button v-else :loading="loading.submit" type="primary" html-type="submit" @click="onSubmitEdit"><b>Save</b></a-button>
          </div>
        </a-col>
      </a-row>
      
    </a-modal>

    <a-modal title="Delete Coa" :centered="true" :visible="modal_delete" @cancel="onModalDeleteClose" :footer="null" :maskClosable="false" width="50%">
      <div>
        <span>Are you sure delete this coa "<strong>{{ delete_state.item.split('/').pop() }}</strong>" ?</span>
      </div>
      <div class="footer-card">
        <a-button type="secondary" html-type="submit" @click="onModalDeleteClose">Cancel</a-button>
        <a-button :loading="loading.delete" type="primary" html-type="submit" @click="deleteCoa"><b>Confirm</b></a-button>
      </div>
    </a-modal>

  </div>
</template>

<script>
import Axios from 'axios';
import { mapGetters } from 'vuex';
import CurrencyFormat from "@/mixins/CurrencyFormat";


export default {
  mixins: [CurrencyFormat],
  data(){
    const columns = [
      {
        title: "Item",
        key: "item",
        // width: 200,
        align: "left",
        scopedSlots: { customRender: "item" },
      },
      // {
      //   title: "Budget Code",
      //   key: "kode_anggaran",
      //   width: 150,
      //   align: "center",
      //   scopedSlots: { customRender: "kode_anggaran" },
      // },
      {
        title: "Total",
        key: "total",
        width: 150,
        align: "right",
        scopedSlots: { customRender: "total" },
      },
    ];

    const columns_coa = [
      {
        title: "Coa Name",
        key: "item",
        // width: 200,
        align: "left",
        scopedSlots: { customRender: "item" },
      },
      {
        title: "Percentage",
        key: "percentage",
        width: 150,
        align: "center",
        scopedSlots: { customRender: "percentage" },
      },
      {
        title: "Total",
        key: "total",
        width: 150,
        align: "right",
        scopedSlots: { customRender: "total" },
      },
      {
        title: "Action",
        key: "action",
        width: 100,
        align: "center",
        scopedSlots: { customRender: "action" },
      }
    ]

    return {
      data_table: [],
      manifest_id: '',
      columns,
      loading: {
        table: false,
        submit: false,
        delete: false
      },
      expandedRowKeys: [],
      edit_state: {
        id: ''
      },
      modal_add: false,
      raw_coa_list: [],
      coa_list: [],
      form: {
        coa_id: '',
        value_coa: 0,
        percentage: 0
      },
      modal_state: 'Create',
      state_value_coa: 0,
      state_budget_code: '',
      state_parent: {},
      modal_delete: false,
      delete_state: {
        item: ''
      },
      columns_coa,
      total_percentage: 0,
      edit_coa_list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      button_state: 'Add'
    }
  },

  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
    ]),

    remainingPercentage(){
      return this.edit_coa_list.reduce((total, item) => {
        return total - Number(item.persentase || 0)
      }, 100)
    },

    remainingValue(){
      return this.edit_coa_list.reduce((total, item) => {
        return total - Number(item.nilai || 0)
      }, this.edit_state.total)
    },

    totalPercentage() {
      return this.edit_coa_list.reduce((total, item) => {
        return total + Number(item.persentase || 0)
      }, 0)
    },

    totalNilai() {
      return this.edit_coa_list.reduce((total, item) => {
        return total + Number(item.nilai || 0)
      }, 0)
    }
  },

  beforeCreate(){
    this.form_create = this.$form.createForm(this);
    this.form_edit = this.$form.createForm(this);
  },

  mounted(){
    this.manifest_id = this.$route.params.id
    this.fetchData()
  },

  methods: {
    getAllKeys(items = []) {
      return items.reduce((keys, item) => {
        keys.push(item.key)

        if (item.children && item.children.length) {
          keys.push(...this.getAllKeys(item.children))
        }

        return keys
      }, [])
    },

    dataNormalize(items = [], parentId = null) {
      const result = []
      for (let i = 0; i < items.length; i++) {
        if (items[i].coa_prn_id === parentId) {
          const node = {
            ...items[i],
            title: `${items[i].coa_code} - ${items[i].coa_nm}`,
            value: items[i].coa_id,
            key: items[i].coa_id
          }

          const children = this.dataNormalize(items, items[i].coa_id)

          if (children.length) {
            node.children = children
            node.selectable = false
            node.className = 'tree-parent'
          }

          result.push(node)
        }
      }
      return result
    },

    onExpand(expanded, record) {
      if (expanded) {
        this.expandedRowKeys.push(record.key)
      } else {
        this.expandedRowKeys =
          this.expandedRowKeys.filter(
            key => key !== record.key
          )
      }
    },

    async fetchData(){
      try {
        this.loading.table = true
        const response = await Axios({
          method: "GET",
          url: this.$serviceUrl + 'anggaran/config_coa',
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            'X-API-KEY': this.getAuth.apikey
          },
          params: {
            anggaran_id: this.$route.params.id
          }
        })
        
        if(response){
          this.data_table = [response.data.budget]
          this.expandedRowKeys = this.getAllKeys(this.data_table)
          this.raw_coa_list = response.data.coa_laba_rugi
          this.coa_list = this.dataNormalize(response.data.coa_laba_rugi)
        }
        this.loading.table = false
        
      } catch (error) {
        console.log(error);
        this.loading.table = false
        
      }
    },

    isParent(record) {
      return !record.path.includes(';')
    },

    findParent(tree, targetId, parent = null) {
      for (const node of tree) {
        if (node.id === targetId) {
          return parent
        }

        if (node.children && node.children.length) {
          const result = this.findParent(
            node.children,
            targetId,
            node
          )

          if (result) {
            return result
          }
        }
      }

      return null
    },

    showModalAdd(val){
      this.modal_add = true
      this.edit_state = val
      this.modal_state = 'Create'

      val.children.forEach(dt => {
        const payload = {
          anggaran_dtl_val_id: this.edit_state.id,
          kode_anggaran: this.edit_state.kode_anggaran,
          coa_id: dt.coa_id,
          persentase: Number(dt.jumlah),
          nilai: dt.total,
          item: `${dt.kode_anggaran} - ${dt.item.includes(' › ') ? dt.item.split(' › ').pop() : dt.item}`
        } 
        
        this.edit_coa_list.push(payload)
      });
    },

    showModalEdit(val){
      this.modal_add = true
      this.edit_state = val
      this.modal_state = 'Edit'
      
      const parent = this.findParent(this.data_table, val.id)
      this.state_value_coa = parent.total
      this.state_budget_code = parent.id
      this.state_parent = parent
      this.$nextTick(() => {
        this.form_create.setFieldsValue({
          coa_id: val.coa_id,
          percentage: val.jumlah,
          value_coa: val.total
        })
      })      
    },

    onModalAddClose(){
      this.modal_add = false
      this.form_create.resetFields()
      this.edit_coa_list = []
      this.button_state = 'Add'
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    onChangePercentage(val){
      const total_value = this.modal_state == 'Create' ? this.edit_state.total : this.state_value_coa
      const calculate = (val/100)*total_value
      this.form_create.setFieldsValue({
        value_coa: calculate
      })
    },

    async onSubmitCreate(){
      this.loading.submit = true
      const totalPercentage = this.edit_coa_list.reduce((total, item) => {
        return total + Number(item.persentase || 0)
      }, 0)

      if (totalPercentage < 100) {
        this.loading.submit = false
        this.$message.error(
          `Total persentase belum 100%. (Saat ini ${totalPercentage}%)`
        )
        return
      }

      try {
        const payload = {
          coa_list:  JSON.stringify(this.edit_coa_list)
        }

        await Axios({
          method: "POST",
          url: this.$serviceUrl + "anggaran/config_coa",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            'X-API-KEY': this.getAuth.apikey
          },
          data: payload
        })
        this.onModalAddClose()
        this.fetchData()
        this.loading.submit = false
        this.displayMessage("success-save")
      } catch (error) {
        this.loading.submit = false
        console.log(error);
        this.displayMessageValue("error-other", error.response.data.message); 
      }
    },

    addDetail() {
      this.form_create.validateFields((err, values) => {
        if (err) return

        const filteredData = this.raw_coa_list.find(
          e => e.coa_id == values.coa_id
        )

        const payload = {
          anggaran_dtl_val_id: this.edit_state.id,
          kode_anggaran: this.edit_state.kode_anggaran,
          coa_id: values.coa_id,
          persentase: Number(values.percentage),
          nilai: values.value_coa,
          item: `${filteredData.coa_code} - ${filteredData.coa_nm}`
        }

        const tempList = [...this.edit_coa_list]

        const index = tempList.findIndex(
          item => item.coa_id == payload.coa_id
        )

        if (index !== -1) {
          tempList[index] = payload
        } else {
          tempList.push(payload)
        }

        const totalPercentage = tempList.reduce((total, item) => {
          return total + Number(item.persentase || 0)
        }, 0)

        if (totalPercentage > 100) {
          this.$message.error(
            `Total persentase tidak boleh lebih dari 100%`
          )
          return
        }

        if (index !== -1) {
          this.$set(this.edit_coa_list, index, payload)
          this.$message.success(
            `Data coa berhasil diubah`
          )
        } else {
          this.edit_coa_list.push(payload)
          this.$message.success(
            `Sukses menambahkan data`
          )
        }
        this.form_create.resetFields()
        this.button_state = 'Add'
      })
    },

    onSubmitEdit(){
      this.loading.submit = true
      this.form_create.validateFields( async (err, values) => {
        if(err){
          this.loading.submit = false
          return
        }

        try {
          const payload = {
            anggaran_dtl_val_id: this.state_parent.id,
            kode_anggaran: this.state_parent.kode_anggaran,
            coa_id: values.coa_id,
            persentase: values.percentage,
            nilai: values.value_coa,
            anggaran_coa_id: this.edit_state.id
          }  

          await Axios({
            method: "PUT",
            url: this.$serviceUrl + "anggaran/config_coa",
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
            },
            headers: {
              'X-API-KEY': this.getAuth.apikey
            },
            data: payload
          })
          this.onModalAddClose()
          this.fetchData()
          this.loading.submit = false
          this.displayMessage("success-save")
        } catch (error) {
          this.loading.submit = false
          console.log(error);
          this.displayMessageValue("error-other", error.response.data.message);
        }

      })
    },

    showModalDelete(val){
      this.modal_delete = true
      this.delete_state = val
    },

    onModalDeleteClose(){
      this.modal_delete = false
    },

    async deleteCoa(){
      this.loading.delete = true
      try {
        const payload = {
          anggaran_coa_id: this.delete_state.id
        }
        await Axios({
          method: "DELETE",
          url: this.$serviceUrl + "anggaran/config_coa",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            'X-API-KEY': this.getAuth.apikey
          },
          data: payload
        })
        this.onModalDeleteClose()
        this.fetchData()
        this.loading.delete = false
      } catch (error) {
        this.loading.delete = false
        console.log(error);
      }
    },

    deleteCoaList(id){
      const temp_data = [...this.edit_coa_list]
      const filter = temp_data.filter((e) => e.coa_id !== id)
      this.edit_coa_list = filter
      this.$message.success(
        `Data coa berhasil dihapus`
      )
    },

    editCoaHanlder(val){
      this.button_state = 'Update'
      this.form_create.setFieldsValue({
        coa_id: val.coa_id,
        percentage: val.persentase,
        value_coa: val.nilai
      })
    },

    cancelEdit(){
      this.button_state = "Add"
      this.form_create.resetFields()
    },

    confirmDelete(){

    },

    cancelDelete(){

    }
  }
}
</script>

<style>
.custom-card .ant-card-body {
  padding: 0px !important;
}

.custom-table .ant-table {
  border: none !important;
}

.custom-table .ant-table-container {
  border-inline-start: none !important;
  border-top: none !important;
}

.custom-table .ant-table-bordered > .ant-table-container {
  border: none !important;
}

.button-edit {
  float: right;
}

.ant-select-tree-treenode[aria-disabled="true"] .ant-select-tree-title {
  font-weight: bold;
}

.ant-select-tree-node-content-wrapper-open {
  font-weight: bold;
}

.ant-select-tree-node-content-wrapper-close {
  font-weight: bold;
}


.footer-card {
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.action-wrapper {
  display: flex;
  gap: 10px;
}

.total-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  padding:  10px 0 0 0;
}

.form-action-section {
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.card-title{
  display: flex;
  justify-content: space-between;
}

</style>